import { ReactNode, useEffect } from "react"
import { useAppSelector } from "../../redux/store/hooks"
import { useLocation, useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"
import { selectProfessionalAuthenticationState } from "../../redux/ProfessionalAuthentication"

interface RequireAuthenticationProps {
    children: ReactNode
}

function RequireAuthentication(props: RequireAuthenticationProps) {
    const authenticated = useAppSelector(selectProfessionalAuthenticationState)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (!authenticated) {
            navigate(NavigationPaths[NAVIGATION_VIEW.SIGN_IN].path)
        }
    }, [authenticated, location])

    return <>{props.children}</>
}

export default RequireAuthentication
